import React from 'react'
import { Toast, Modal } from 'antd-mobile'
import {
  saveAssign,
  saveBatchAssign,
  getAssignDetail,
  getUserSimpleList,
  getProjectSimpleList,
  getLiftSimpleList,
} from '../../../api/TaskAssigned'
import './AddAssign.scss'

class AddAssign extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      // 表单
      userId: '',
      projectId: '',
      liftId: [],       // 新增时数组
      liftIdSingle: '',  // 编辑时单值
      taskName: '',
      taskType: '',
      ownerPayAmount: '',
      companyPayAmount: '',
      startTime: '',
      endTime: '',
      // 联动选项
      userList: [],
      projectList: [],
      liftList: [],
      // 搜索关键字
      userKeyword: '',
      projectKeyword: '',
      liftKeyword: '',
      // 搜索框聚焦状态
      userSearchFocus: false,
      projectSearchFocus: false,
    }
    this.userSearchTimer = null
    this.projectSearchTimer = null
  }

  componentDidMount() {
    this.fetchUserList()
    this.fetchProjectList()
    // 编辑模式回显
    if (this.props.editData && this.props.editData.id) {
      this.fetchDetail(this.props.editData.id)
    }
  }

  // 获取详情回显
  fetchDetail = async (id) => {
    try {
      const res = await getAssignDetail({ id })
      if (res.code === 200 && res.data) {
        const d = res.data
        this.setState({
          userId: d.userId || '',
          liftIdSingle: d.liftId || '',
          taskName: d.taskName || '',
          taskType: d.taskType !== undefined ? String(d.taskType) : '',
          ownerPayAmount: d.ownerPayAmount != null ? String(d.ownerPayAmount) : '',
          companyPayAmount: d.companyPayAmount != null ? String(d.companyPayAmount) : '',
          startTime: d.startTime || '',
          endTime: d.endTime || '',
        })
        // 如果有 liftId，需要加载电梯列表
        if (d.projectId) {
          this.setState({ projectId: String(d.projectId) })
          this.fetchLiftList(d.projectId)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  // 员工列表
  fetchUserList = async (keyword) => {
    try {
      const params = { size: 100 }
      if (keyword) params.keyword = keyword
      const res = await getUserSimpleList(params)
      if (res.code === 200 && res.data) {
        this.setState({ userList: res.data })
      }
    } catch (e) {
      console.error(e)
    }
  }

  // 项目列表
  fetchProjectList = async (keyword) => {
    try {
      const params = { size: 1000 }
      if (keyword) params.keyword = keyword
      const res = await getProjectSimpleList(params)
      if (res.code === 200 && res.data) {
        this.setState({ projectList: res.data })
      }
    } catch (e) {
      console.error(e)
    }
  }

  // 电梯列表（依赖 projectId）
  fetchLiftList = async (projectId, keyword) => {
    if (!projectId) {
      this.setState({ liftList: [], liftId: [], liftIdSingle: '' })
      return
    }
    try {
      const params = { projectId, size: 100 }
      if (keyword) params.keyword = keyword
      const res = await getLiftSimpleList(params)
      if (res.code === 200 && res.data) {
        this.setState({ liftList: res.data })
      }
    } catch (e) {
      console.error(e)
    }
  }

  // 员工搜索（防抖）
  handleUserSearch = (keyword) => {
    this.setState({ userKeyword: keyword })
    if (this.userSearchTimer) clearTimeout(this.userSearchTimer)
    this.userSearchTimer = setTimeout(() => {
      this.fetchUserList(keyword)
    }, 400)
  }

  // 项目搜索（防抖）
  handleProjectSearch = (keyword) => {
    this.setState({ projectKeyword: keyword })
    if (this.projectSearchTimer) clearTimeout(this.projectSearchTimer)
    this.projectSearchTimer = setTimeout(() => {
      this.fetchProjectList(keyword)
    }, 400)
  }

  // 字段修改
  handleChange = (field, value) => {
    this.setState({ [field]: value })
  }

  // 选择项目后联动电梯
  handleProjectChange = (value) => {
    this.setState({ projectId: value, liftId: [], liftIdSingle: '', liftList: [] })
    if (value) {
      this.fetchLiftList(value)
    }
  }

  // 电梯多选（新增模式）
  handleLiftMultiChange = (liftId) => {
    this.setState(prev => {
      const exists = prev.liftId.includes(liftId)
      return {
        liftId: exists ? prev.liftId.filter(id => id !== liftId) : [...prev.liftId, liftId]
      }
    })
  }

  // 校验
  validate = () => {
    const { userId, taskName, taskType, startTime, endTime, projectId } = this.state
    const isEdit = !!this.props.editData
    const liftId = isEdit ? this.state.liftIdSingle : this.state.liftId

    if (!userId) { Toast.fail('请选择员工', 1); return false }
    if (!projectId) { Toast.fail('请选择项目', 1); return false }
    if (!liftId || (Array.isArray(liftId) && liftId.length === 0)) { Toast.fail('请选择电梯', 1); return false }
    if (!taskName) { Toast.fail('请输入任务名称', 1); return false }
    if (!taskType) { Toast.fail('请选择事项', 1); return false }
    if (!startTime) { Toast.fail('请选择开始日期', 1); return false }
    if (!endTime) { Toast.fail('请选择结束日期', 1); return false }
    if (startTime && endTime && endTime < startTime) { Toast.fail('结束日期不能早于开始日期', 1); return false }
    return true
  }

  // 提交
  handleSubmit = async () => {
    if (!this.validate()) return
    const isEdit = !!this.props.editData
    const {
      userId, taskName, taskType, ownerPayAmount, companyPayAmount,
      startTime, endTime, liftIdSingle, liftId
    } = this.state

    this.setState({ loading: true })
    try {
      let res
      if (isEdit) {
        res = await saveAssign({
          id: this.props.editData.id,
          userId: Number(userId),
          liftId: Number(liftIdSingle),
          taskName,
          taskType: Number(taskType),
          ownerPayAmount: ownerPayAmount ? Number(ownerPayAmount) : undefined,
          companyPayAmount: companyPayAmount ? Number(companyPayAmount) : undefined,
          startTime,
          endTime,
        })
      } else {
        res = await saveBatchAssign({
          userId: Number(userId),
          liftId: liftId.map(id => Number(id)),
          taskName,
          taskType: Number(taskType),
          ownerPayAmount: ownerPayAmount ? Number(ownerPayAmount) : undefined,
          companyPayAmount: companyPayAmount ? Number(companyPayAmount) : undefined,
          startTime,
          endTime,
          status:1
        })
      }
      if (res.code === 200) {
        Toast.success(isEdit ? '编辑成功' : '新增成功', 1)
        this.props.onSuccess && this.props.onSuccess()
      } else {
        Toast.fail(res.message || '操作失败', 1)
      }
    } catch (e) {
      Toast.fail('操作失败', 1)
    } finally {
      this.setState({ loading: false })
    }
  }

  // 关闭
  handleClose = () => {
    this.props.onClose && this.props.onClose()
  }

  // 阻止冒泡
  stopPropagation = (e) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
  }

  render() {
    const {
      userId, projectId, liftId, liftIdSingle, taskName, taskType,
      ownerPayAmount, companyPayAmount, startTime, endTime,
      userList, projectList, liftList, loading,
      userKeyword, projectKeyword, userSearchFocus, projectSearchFocus
    } = this.state
    const isEdit = !!this.props.editData

    return (
      <div className="add-assign-overlay" onClick={this.handleClose}>
        <div className="add-assign-modal" onClick={this.stopPropagation}>
          <div className="modal-header">
            <span className="modal-title">{isEdit ? '编辑任务' : '新增任务'}</span>
            <span className="modal-close" onClick={this.handleClose}>×</span>
          </div>

          <div className="modal-body">
            {/* 员工选择 */}
            <div className="form-field">
              <label><span className="required">*</span>员工</label>
              <div className="select-with-search">
                <input
                  type="text"
                  className="select-search-input"
                  placeholder="搜索员工..."
                  value={userKeyword}
                  onChange={e => this.handleUserSearch(e.target.value)}
                  onFocus={() => this.setState({ userSearchFocus: true })}
                  onBlur={() => setTimeout(() => this.setState({ userSearchFocus: false }), 200)}
                />
                <select value={userId} onChange={e => this.handleChange('userId', e.target.value)}>
                  {<option value="">请选择员工</option>}
                  {userList.map(u => (
                    <option key={u.userId} value={u.userId}>{u.nickname}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* 项目选择 */}
            <div className="form-field">
              <label><span className="required">*</span>项目</label>
              <div className="select-with-search">
                <input
                  type="text"
                  className="select-search-input"
                  placeholder="搜索项目..."
                  value={projectKeyword}
                  onChange={e => this.handleProjectSearch(e.target.value)}
                  onFocus={() => this.setState({ projectSearchFocus: true })}
                  onBlur={() => setTimeout(() => this.setState({ projectSearchFocus: false }), 200)}
                />
                <select value={projectId} onChange={e => this.handleProjectChange(e.target.value)}>
                  { <option value="">请选择项目</option>}
                  {projectList.map(p => (
                    <option key={p.id} value={p.id}>{p.projectName}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* 电梯选择 */}
            <div className="form-field">
              <label><span className="required">*</span>电梯</label>
              {isEdit ? (
                // 编辑模式：单选
                <select
                  value={liftIdSingle}
                  onChange={e => this.handleChange('liftIdSingle', e.target.value)}
                  disabled={!projectId}
                >
                  <option value="">{projectId ? '请选择电梯' : '请先选择项目'}</option>
                  {liftList.map(l => (
                    <option key={l.liftId} value={l.liftId}>{l.liftLocation}</option>
                  ))}
                </select>
              ) : (
                // 新增模式：多选
                <div className="lift-multi-select">
                  {!projectId ? (
                    <div className="lift-placeholder">请先选择项目</div>
                  ) : liftList.length === 0 ? (
                    <div className="lift-placeholder">暂无电梯</div>
                  ) : (
                    <div className="lift-checkbox-list">
                      {liftList.map(l => (
                        <label key={l.liftId} className="lift-checkbox-item">
                          <input
                            type="checkbox"
                            checked={liftId.includes(l.liftId)}
                            onChange={() => this.handleLiftMultiChange(l.liftId)}
                          />
                          <span>{l.liftLocation}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* 任务名称 */}
            <div className="form-field">
              <label><span className="required">*</span>任务名称</label>
              <input
                type="text"
                placeholder="请输入任务名称"
                value={taskName}
                onChange={e => this.handleChange('taskName', e.target.value)}
              />
            </div>

            {/* 事项 */}
            <div className="form-field">
              <label><span className="required">*</span>事项</label>
              <select value={taskType} onChange={e => this.handleChange('taskType', e.target.value)}>
                <option value="">请选择事项</option>
                <option value="1">维保</option>
                <option value="2">维修</option>
              </select>
            </div>

            {/* 负责人支付金额 */}
            <div className="form-field">
              <label>负责人支付金额</label>
              <input
                type="number"
                placeholder="请输入金额"
                value={ownerPayAmount}
                onChange={e => this.handleChange('ownerPayAmount', e.target.value)}
              />
            </div>

            {/* 公司支付金额 */}
            <div className="form-field">
              <label>公司支付金额</label>
              <input
                type="number"
                placeholder="请输入金额"
                value={companyPayAmount}
                onChange={e => this.handleChange('companyPayAmount', e.target.value)}
              />
            </div>

            {/* 开始日期 */}
            <div className="form-field">
              <label><span className="required">*</span>开始日期</label>
              <input
                type="date"
                value={startTime}
                onChange={e => this.handleChange('startTime', e.target.value)}
              />
            </div>

            {/* 结束日期 */}
            <div className="form-field">
              <label><span className="required">*</span>结束日期</label>
              <input
                type="date"
                value={endTime}
                onChange={e => this.handleChange('endTime', e.target.value)}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={this.handleClose} disabled={loading}>取消</button>
            <button className="btn-confirm" onClick={this.handleSubmit} disabled={loading}>
              {loading ? '提交中...' : '确定'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default AddAssign
